export default "__VITE_ASSET__DAPxrwBQ__"